/* eslint-disable prefer-rest-params */
/* eslint-disable camelcase */
import {
  Card,
  Typography,
  CardContent,
  CardActions,
  Divider,
  Grid,
  Badge,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ProjectManager, ProjectProps } from '../../../../config/interfaces';
import ButtonsProject from './buttons-action';
import Avatar from '../../avatar';
import { setCurrentProject, setIdCurrentProject } from '../../../../hooks/projectsInfo';

export default function CardProject(props: ProjectProps) {
  const { project, refetch } = props;
  const navigate = useNavigate();

  const isNewProject = project.is_new_project ? (
    <Badge
      sx={{
        zIndex: 1000,
        position: 'absolute',
        right: 30,
        top: 15,
      }}
      badgeContent="new"
      color="info"
    />
  ) : null;

  const lineProducer = project.project_managers.map((manager: ProjectManager) => {
    if (manager.user_role === 'LINE_PRODUCER') {
      return (
        <Grid
          key={manager.id}
          sx={{
            with: '100%',
            display: 'flex',
            justifyContent: 'center',
            my: 2,
          }}
        >
          <Avatar
            url={manager.url_avatar}
            size={40}
            mrSVG={3}
            style={{
              marginRight: '27px',
              marginTop: '3px',
              width: '34px',
              height: '34px',
            }} />
          <Grid
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography
              component="p"
              variant="body1"
              sx={{
                m: 0,
                fontSize: '0.875rem',
                fontWeight: '300'
              }}
            >
              {manager.full_name}
            </Typography>
            <Typography
              component="p"
              variant="body2"
              sx={{
                m: 0,
                fontWeight: '500',
                fontSize: '0.875rem',
              }}
            >
              Line Producer
            </Typography>
          </Grid>
        </Grid>
      );
    }
    return null;
  });

  const goToProject = () => {
    setCurrentProject(project);
    setIdCurrentProject(project.id);
    navigate(`/project/${project.id}/creative-docs`);
  };

  return (
    <Card
      sx={{
        width: '300px',
        mr: 4,
        my: 2,
        background: project.status === 'DONE' ? '#E5E5E5' : '#FFFFFF',
        boxShadow: '0px 0px 20px #D1D5DF80',
        position: 'relative',
        cursor: 'pointer',
      }}
      onClick={goToProject}
    >
      {isNewProject}
      <CardContent sx={{
        padding: '24px',
      }}>
        <Typography
          component="h3"
          variant="h3"
          sx={{
            m: 0,
            color: '#323643',
            fontWeight: 500,
          }}
        >
          {project.project_name}
        </Typography>
        <Typography
          component="p"
          variant="body2"
          sx={{
            m: 0,
            fontSize: '0.875rem',
            fontWeight: '300'
          }}
        >
          Project #
          {project.num_project}
        </Typography>
        <Divider
          sx={{
            mt: 1,
            mb: 3,
            mr: -3,
            ml: -3,
            borderColor: '#CFD3DD',
          }}
        />
        <Grid
          sx={{
            with: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Avatar
            url={project.company ? project.company.url_file : ''}
            size={40}
            mrSVG={3}
            style={{
              marginRight: '27px',
              marginTop: '3px',
              width: '34px',
              height: '34px'
            }} />
          <Grid
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography
              component="p"
              variant="body1"
              sx={{
                m: 0,
                fontWeight: '300',
                fontSize: '0.875rem',
              }}
            >
              {project.company ? project.company.company_name : 'My Project'}
            </Typography>
            <Typography
              component="p"
              variant="body2"
              sx={{
                m: 0,
                fontWeight: '500',
                fontSize: '0.875rem',
              }}
            >
              Production Company
            </Typography>
          </Grid>
        </Grid>
        {lineProducer}
        <Grid
          sx={{
            with: '100%',
            display: 'flex',
            flexDirection: 'column',
            mt: 2,
          }}
        >
          <Typography
            component="p"
            variant="body2"
            sx={{
              m: 0,
              fontWeight: '500',
              fontSize: '0.875rem',
            }}
          >
            Calendar
          </Typography>
          <Typography
            component="p"
            variant="body1"
            sx={{
              m: 0,
              fontWeight: '500',
              fontSize: '0.875rem',
            }}
          >
            {project.start_date}
            {' '}
            -
            {' '}
            {project.end_date}
          </Typography>
        </Grid>
      </CardContent>
      <CardActions
        sx={{
          padding: '0px 24px 24px 24px'
        }}
      >
        <ButtonsProject project={project} refetch={refetch} />
      </CardActions>
    </Card>
  );
}
